import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'

export const getErrorStyle = (): SerializedStyles => css`
  outline: 2px solid ${Color.Red700};
  outline-offset: -2px;
  background-color: ${Color.White};
`
